import Arion from "@/assets/arion.svg?react";
import ISB from "@/assets/isb.svg?react";
import LBI from "@/assets/lbi.svg?react";
import Kvika from "@/assets/kvika.svg?react"; // Icons are duplicated. TODO: Fix later.

export const renderBankName = (paymentProvider: string): string => {
  switch (paymentProvider) {
    case "arion":
      return "Arion";
    case "aur":
      return "Kvika";
    case "kvika":
      return "Kvika";
    case "lbi":
      return "Landsbankinn";
    case "isb":
      return "Íslandsbanki";
    default:
      return "";
  }
};

export const renderBankIconComponent = (paymentProvider: string) => {
  switch (paymentProvider) {
    case "arion":
      return <Arion height={20} width={20} color="#005ab4" />;
    case "aur":
      return <Kvika height={20} width={20} color="#907140" />;
    case "kvika":
      return <Kvika height={20} width={20} color="#907140" />;
    case "lbi":
      return <LBI height={20} width={20} color="#ff0000" />;
    case "isb":
      return <ISB height={20} width={20} color="#dc1e35" />;
    default:
      return null;
  }
};

export function constructBBAN(bban: string): string {
  if (!bban) return "";
  // Remove any existing dashes
  const clean = bban.replace(/-/g, "");
  // Format as 1234-12-123456
  return `${clean.slice(0, 4)}-${clean.slice(4, 6)}-${clean.slice(6)}`;
}

export const constructExternalIdWithDash = (externalId: string): string => {
  if (!externalId) {
    return "";
  }
  let str = "";
  Array.from(externalId).forEach((elem, index) => {
    if (index === 6) {
      str = str + "-" + elem;
    } else {
      str = str + elem;
    }
  });
  return str;
};
